import { LoanStatus as GqlLoanStatus } from '@willow/graphql-iso/src/app/backend';
import { LoanStatus } from '@willow/types-iso';

export const gqlLoanStatusToLoanStatus = (loanStatus: GqlLoanStatus): LoanStatus => {
  switch (loanStatus) {
    case GqlLoanStatus.Active:
      return 'active';
    case GqlLoanStatus.Archived:
      return 'archived';
    case GqlLoanStatus.PaidOff:
      return 'paidOff';
    case GqlLoanStatus.PendingActivation:
      return 'pendingActivation';
    case GqlLoanStatus.PendingTransfer:
      return 'pendingTransfer';
    case GqlLoanStatus.PreActive:
      return 'preActive';
    case GqlLoanStatus.Transferred:
      return 'transferred';
    case GqlLoanStatus.Reo:
      return 'reo';
    case GqlLoanStatus.Liquidated:
      return 'liquidated';
    default:
      assertNever(loanStatus);
  }
};

export const loanStatusToGqlLoanStatus = (loanStatus: LoanStatus): GqlLoanStatus => {
  switch (loanStatus) {
    case 'active':
      return GqlLoanStatus.Active;
    case 'archived':
      return GqlLoanStatus.Archived;
    case 'foreclosure':
      return GqlLoanStatus.Active;
    case 'paidOff':
      return GqlLoanStatus.PaidOff;
    case 'pendingActivation':
      return GqlLoanStatus.PendingActivation;
    case 'pendingTransfer':
      return GqlLoanStatus.PendingTransfer;
    case 'preActive':
      return GqlLoanStatus.PreActive;
    case 'transferred':
      return GqlLoanStatus.Transferred;
    case 'reo':
      return GqlLoanStatus.Reo;
    case 'liquidated':
      return GqlLoanStatus.Liquidated;
    default:
      assertNever(loanStatus);
  }
};

/**
 * TODO deduplicate this one with the others
 */
function assertNever(value: never): never {
  throw new Error(`Unexpected value: ${value}`);
}
